import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    loginErrorMessage: PropTypes.string
};
const defaultProps = {};

function VerifyPassword(props) {
    const { loginErrorMessage } = props;

    return (
        <div id="passwordField">
            {loginErrorMessage && (
                <div className="is-warning">
                    <p className="asc-form-help">{loginErrorMessage}</p>
                </div>
            )}
            <label className="asc-acc-hidden" htmlFor="password">
                Password
            </label>
            <input
                className="asc-form-input asc-form-input-verification"
                type="password"
                id="password"
                name="password"
                placeholder="Password"
                required
            />
        </div>
    );
}

VerifyPassword.propTypes = propTypes;
VerifyPassword.defaultProps = defaultProps;
export default VerifyPassword;
